type PaymentCallbackOptions = {
  returnTo: "saleOrder" | "dashboard" | "wallet";
  type: string;
  checkoutId?: string;
};

export function buildPaymentCallbackUrl({
  returnTo,
  type,
  checkoutId,
}: PaymentCallbackOptions): string {
  const params = new URLSearchParams({ returnTo, type });
  if (checkoutId) params.set("id", checkoutId);
  return `${window.location.origin}/payment-callback?${params.toString()}`;
}
